module.exports = __webpack_public_path__ + "img/cooperationImg6.ec779cf7.png";